import React from 'react';
import styled from 'styled-components';
import { Styling } from '../../constants';
import { SettingType } from '../../api/vault/publishEndpoints';
import youTubeLogo from '../../images/yt_icon_rgb.png';
import twitterLogo from '../../images/twitter.png';
import twitterLogoWhite from '../../images/twitter-white.png';
import { filterI18nProps } from '../../utils/styledComponentsUtils';

const typeToLogoSrcMap = new Map([
  [SettingType.YouTube, youTubeLogo],
  [SettingType.Twitter, twitterLogo],
  [SettingType.Twitter_White, twitterLogoWhite],
]);

const IconContainer = styled.span`
  display: flex;
  justify-content: center;
  margin: 0 ${Styling.SOCIAL_ICON_SPACING}px 0 0;
  width: ${Styling.WIDEST_SOCIAL_ICON}px;
`;

const IconImg = styled.img`
  height: ${(props) => (props.height || '30px')};
  display: block;
`;

const TwitterContainer = styled.span`
  display: flex;
  justify-content: center;
`;

const TwitterImg = styled.img`
  height: 20px;
  width: 20px;
  display: block;
`;

interface IIconProps {
  type: SettingType,
}

const SocialIcon: React.FC<IIconProps> = (props) => {
  const { type } = props;
  if (typeToLogoSrcMap.get(type) === twitterLogoWhite) {
    return (
      <TwitterContainer>
        <TwitterImg {...filterI18nProps(props)} src={typeToLogoSrcMap.get(type)} />
      </TwitterContainer>
    );
  }
  return (
    <IconContainer>
      <IconImg {...filterI18nProps(props)} src={typeToLogoSrcMap.get(type)} />
    </IconContainer>
  );
};
export default SocialIcon;
